import Image from "next/legacy/image";
import MediaAssets from "../utils/MediaAssets";
import ExitButton from '@components/icons/ExitButton'

interface ISuccessScreenProps {
  onRequestOpen: (isOpen: boolean) => void;
}

function SuccessScreen({ onRequestOpen }: ISuccessScreenProps): JSX.Element {
  return (
    <div>
      <div className="absolute top-0 z-[60] h-screen w-full overflow-hidden bg-white scrollbar-hide">
        <div className="absolute top-3 left-3 z-20">
          <Image
            src={MediaAssets.getAsset("frog_request_quote")}
            width="36"
            height="36"
            layout="fixed"
            alt="Request a quote"
          />
        </div>
        <div className="absolute top-3 right-3 z-20">
          <ExitButton onClick={onRequestOpen}/>
        </div>

        <div className="relative bg-blue-5">
          <div className="relative top-12 bg-blue-5">
            <div className="flex h-[350px] w-[1900px] justify-center">
              <Image
                src={MediaAssets.getAsset("success_screen_background")}
                width="1600"
                height="350"
                objectFit="cover"
                alt={"form background image"}
              />
            </div>
          </div>
        </div>
        <div className="mx-auto mt-12 w-[90%] text-center desktop:w-[50%]">
          <h1
            id="submit-thank-you"
            className="text-h1 font-semibold leading-[115%] desktop:leading-[120%]"
          >
            Thank you for contacting us!
          </h1>
          <h3 className="mt-[20px] text-h3 font-medium">
            A local Travel Expert will respond to you within an hour. They will
            work with you to design a personalized trip quote.
          </h3>
        </div>
      </div>
    </div>
  );
}

export default SuccessScreen;
